// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"styles_footerContainer__1JIPB","btn":"styles_btn__2bldQ","container":"styles_container__30v5u"};